import { AbstractControl } from '@angular/forms';

export function AutoCompleteValidator(control: AbstractControl) {
  if ((control.value) && (control.value.id)) {
      return null;
    } else {
      return { required: true };
    }
}
